import { useState, useEffect, useRef, useCallback } from "react";
import { BadgeIndianRupee, RotateCw } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import ExposureRightNavDrawer from "./ExposureRightNavDrawer";
import FinancialButtons from "../FinancialBtn/FinancialButtons";
import {
  updateAvailableBalance,
  updateExposureBalance,
} from "../../redux/slices/userSlice";
import { fetchuserdata } from "../../api";
import { getUserId, isSignupUser } from "../../utils/helper/commonSelectors";
import { toggleRightSidebar } from "../../redux/slices/sidebarSlice";

function BalanceDisplay() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.user?.userData) || {};
  const accountType = useSelector((state) => state?.account?.accountType) || "";
  const userId = useSelector(getUserId());
  const [isLoadingBalance, setIsLoadingBalance] = useState(false);
  const [isLoadingExposure, setIsLoadingExposure] = useState(false);
  const isFetchingBalance = useRef(false);
  const isFetchingExposure = useRef(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const signupUser = useSelector(isSignupUser());

  const exposure = Number(userData?.exposure || 0);

  const availableBalance = Number(userData.availableBalance - exposure || 0);
  const refProfitLoss = Number(userData?.refProfitLoss || 0);
  const ExposureData = { availableBalance, exposure, refProfitLoss };

  // console.log({availableBalance})

  const handleToggleDrawer = () => {
    dispatch(toggleRightSidebar());
  };

  const fetchBalanceData = useCallback(async () => {
    if (isFetchingBalance.current) return;
    isFetchingBalance.current = true;
    setIsLoadingBalance(true);

    try {
      const res = await fetchuserdata(userId);
      if (res?.success) {
        dispatch(updateAvailableBalance(res?.data?.userdata?.availableBalance));
        dispatch(updateExposureBalance(res?.data?.userdata?.exposure));
      }
    } catch (error) {
      console.error("Error fetching balance data:", error);
    } finally {
      isFetchingBalance.current = false;
      setIsLoadingBalance(false);
    }
  }, [userId, dispatch]);

  const fetchExposureData = useCallback(async () => {
    if (isFetchingExposure.current) return;
    isFetchingExposure.current = true;
    setIsLoadingExposure(true);

    try {
      const res = await fetchuserdata(userId);
      if (res?.success) {
        dispatch(updateExposureBalance(res?.data?.userdata?.exposure));
      }
    } catch (error) {
      console.error("Error fetching exposure data:", error);
    } finally {
      isFetchingExposure.current = false;
      setIsLoadingExposure(false);
    }
  }, [userId, dispatch]);

  useEffect(() => {
    if (accountType === "real") {
      fetchExposureData();
    }
  }, [fetchBalanceData]);

  // const fetchSettledBets = async () => {
  //   try {
  //     const res = await getUnsettledBets();
  //     const bets = res?.data?.data || res?.data || [];

  //     if (JSON.stringify(bets) === JSON.stringify(prevBets)) {
  //       // console.log("No changes in data, skipping fetch...");
  //       return;
  //     }

  //     const totalStake = Array.isArray(bets) ?  bets?.reduce(
  //       (acc, e) => acc + (e?.againstMargin || 0),
  //       0
  //     ) : 0

  //     setExpdata(totalStake);
  //     setPrevBets(bets);
  //   } catch (error) {
  //     console.error("Error fetching unsettled bets:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchSettledBets();
  // }, []);

  return (
    <>
      {accountType === "real" && signupUser ? <FinancialButtons /> : null}

      <div className="flex items-center space-y-2 sm:space-y-0 space-x-2">
        <div className="flex flex-col space-y-1 text-xs cursor-pointer w-full sm:w-auto">
          <div className="flex gap-1">
            <div
              className="bg-footerbg rounded-md flex  px-3 items-center justify-between space-x-1 w-full sm:w-auto"
              onClick={handleToggleDrawer}
            >
              <BadgeIndianRupee className="text-gold" size={12} />
              <span className="text-white font-semibold text-[8.5px] sm:text-[11px]">
                {availableBalance?.toFixed(0)}
              </span>
            </div>
            <button
              onClick={fetchBalanceData}
              disabled={isLoadingBalance}
              className="bg-footerbg p-1.5 rounded-md border-none cursor-pointer w-full sm:w-auto"
            >
              <RotateCw
                size={12}
                className={`text-yellow-100 mx-auto ${
                  isLoadingBalance ? "animate-spin" : ""
                }`}
              />
            </button>
          </div>

          <div
            className="bg-footerbg rounded-md p-1 px-3 flex items-center justify-center sm:justify-start space-x-1 w-full sm:w-auto"
            onClick={handleToggleDrawer}
          >
            <span className="text-white font-semibold text-[8.5px] sm:text-[11px]">
              Exp : {exposure?.toFixed()}
            </span>
          </div>
        </div>
      </div>

      <ExposureRightNavDrawer
        isOpen={isDrawerOpen}
        toggleDrawers={handleToggleDrawer}
        exposuredata={ExposureData}
        userType="real"
      />
    </>
  );
}

export default BalanceDisplay;
